import React, { useRef, useState, useEffect } from 'react';

const VideoPage = () => {
  alert('test');
  const [lightFirstTime, setLightFirstTime] = useState(true);
  const [readyClick, setReadyClick] = useState(false);
  const [firstTime, setFirstTime] = useState(true);
  const [myArr, setMyArr] = useState([]);
  const [countBln, setCountBln] = useState(false);
  const [countNewRun, setCountNewRun] = useState(false);
  const [count, setCount] = useState(0);
  const [countNew, setCountNew] = useState(0);
  const [countNum, setCountNum] = useState(0);
  const [changeVal, setChangeVal] = useState(false);
  const [averageBrightness, setAverageBrightness] = useState(0);
  const [totalBrightness, setTotalBrightness] = useState(0);
  const [multyTotalClr, setMultyTotalClr] = useState(0);
  const [imageData, setImageData] = useState();
  const [data, setData] = useState();
  const [red, setRed] = useState();
  const [green, setGreen] = useState();
  const [blue, setBlue] = useState();
  const [brightness, setBrightness] = useState();
  const [getTxt, setGetTxt] = useState('');
  const [topDiv, setTopDiv] = useState(false);
  const [tuesday, setTuesday] = useState(false);
  const [wednesday, setWednesday] = useState(false);
  const [loader1, setLoader1] = useState(false);
  const [monday, setMonday] = useState(false);
  const [content, setContent] = useState(''); 
  const [finalresult, setFinalresult] = useState([]);
  const [video, setVideo] = useState(); 
  const myVideotagRef = useRef(null);
  
  const clickReadyHandler = () => {
    // alert('clickReadyHandler 1');
    setReadyClick(true);
  };

  // Get the existing video tag element
  const myVideotagElement = myVideotagRef.current;

  const endTask = () => {
    // alert('endTask 4');
    setFirstTime(false);
    setLightFirstTime(false);
    setReadyClick(false)
  }

  const everyTimeCheck = () => {    
    // alert('everyTimeCheck 5');
    const element = document.querySelector('.alpha');
    if (element) {
      setGetTxt(element.innerHTML);
    }
    if(getTxt.match("MM")  || getTxt.match("MMM")){
      //  alert('mm aaya hai');
       setTopDiv(false);
       setTuesday(false);
       setWednesday(false)
       setLoader1(false)
       setMonday(true);

       endTask();
    }
    if(getTxt.match("22") || getTxt.match("222")){
      //  alert('22 aaya hai');
       setTopDiv(false);
       setMonday(false);
       setWednesday(false);
       setLoader1(false);
       setTuesday(true);

      endTask();
    }
    if(getTxt.match("##") || getTxt.match("###")){
      //  alert('## aaya hai');
       setTopDiv(false);
       setMonday(false);
       setTuesday(false);
       setLoader1(false);
       setWednesday(true);
       
      endTask();
    }
  }

  const typeChr = () => {
    // alert('typeChr 6');
    setChangeVal(false);
    setCountNew(0);

    let currentString = '';

    for (let i = 0; i < myArr.length; i++) {
      if (myArr[i] === ' ') {
        if (currentString !== '') {
          const updatedFinalresult = [...finalresult, currentString];
          setFinalresult(updatedFinalresult);
          currentString = '';
        }
      } else {
        currentString += myArr[i];
      }
    }

    if (currentString !== '') {
      const updatedFinalresult1 = [...finalresult, currentString];
      setFinalresult(updatedFinalresult1);
    }

    for (let i = 0; i < finalresult.length; i++) {
      const num = finalresult[i];
      if (num === '?') {
        setContent(prevContent => prevContent + ' ');
      }
      if (num === '.') {
        setContent(prevContent => prevContent + 'M');
      }
      if (num === '..') {
        setContent(prevContent => prevContent + '2');
      }
      if (num === '...') {
        setContent(prevContent => prevContent + '#');
      } 
      if (num === '-') {
        setContent(prevContent => prevContent + 'Y');
      }   
                     
      everyTimeCheck();
      setMyArr([]);
      const updatedFinalresult2 = [];
      setFinalresult(updatedFinalresult2);
    }

  }

  const processFrame = () => {
    // alert('processFrame 7');
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');
    // canvas.width = video.videoWidth;
    // canvas.height = video.videoHeight;
    canvas.width = 480;
    canvas.height = 480;
    
    if (context) {
      // alert('enter');
      context.drawImage(video, 0, 0, canvas.width, canvas.height);
      const imageDataFst = context.getImageData(0, 0, canvas.width, canvas.height); 
      // alert('imageData ' + imageData);
      setImageData(imageDataFst);
      const imageDataNew = imageDataFst.data;
      setData(imageDataNew);
      // alert('imageDataNew ' + imageDataNew);
      
      for (let i = 0; i < imageDataNew.length; i += 4) {
        const redClr = imageDataNew[i]; 
        setRed(redClr);
        const grnClr = imageDataNew[i + 1]; 
        setGreen(grnClr);
        const blueClr = imageDataNew[i + 2]; 
        setBlue(blueClr);
        const multyClr = (redClr + grnClr + blueClr) / 3; 
        setBrightness(multyClr);

        alert('multyClr ' + multyClr);

        const getMultyTotalClr = (multyClr) => {
          setMultyTotalClr((prevMultyTotalClr) => prevMultyTotalClr + multyClr);
          alert('MultyTotalClr  ' + multyTotalClr);
        };

        getMultyTotalClr(multyClr);

        // const totalClr = multyTotalClr + multyClr; 
        // alert('totalClr ' + totalClr);
        // setTotalBrightness(totalClr);

        setTotalBrightness(multyTotalClr);
      }
      
      // alert('totalBrightness ' + totalBrightness);
      const bright = totalBrightness / (canvas.width * canvas.height);
      alert('bright ' + bright);
      setAverageBrightness(bright);
      setCountNum(countNum + 1);
    
      if(lightFirstTime === true && readyClick === true ){
        if(averageBrightness > 120){
          setChangeVal(true);
          setCountBln(true);
          
          if(countNew > 35){
            if(countNewRun === true){
              setCountNewRun(false);                 
              typeChr();

              const updatedArr0 = [...myArr, '?'];
              setMyArr(updatedArr0);

              typeChr();
            }
          } else if(countNew > 25){
            const updatedArr1 = [...myArr, ' '];
            setMyArr(updatedArr1);
            typeChr();
          } else{
            setCount(count + 1);
          }
        } else{
          if(count <= 15 && countBln === true){
              const updatedArr2 = [...myArr, '.'];
              setMyArr(updatedArr2);
              setCount(0);
              setCountNew(0);
              setCountBln(false);
              setCountNew(0);
              setCountNewRun(true);
          } 
          if(count >= 16 && countBln === true){
              const updatedArr3 = [...myArr, '-'];
              setMyArr(updatedArr3);
              setCount(0);
              setCountNew(0);
              setCountBln(false);
              setCountNew(0);
              setCountNewRun(true);
          }


          if(changeVal === true){
            setCountNew(countNew + 1);

            if(countNew > 120 && firstTime === true){

              setFirstTime(false);
              setLightFirstTime(false);
              setReadyClick(false);
              
              typeChr();   
              setTimeout(() => {
                // location.reload();
                const element = document.querySelector('.alpha');
                if (element) {
                  setGetTxt(element.innerHTML);
                }
                // alert(getTxt);
                
                if(getTxt.match("MM")  || getTxt.match("MMM")){
                  alert('mm aaya hai');
                  
                  setTopDiv(false);
                  setTuesday(false);
                  setWednesday(false);
                  setLoader1(false);

                  setMonday(true);

                }
                if(getTxt.match("22") || getTxt.match("222")){
                  alert('22 aaya hai');

                  setTopDiv(false);
                  setMonday(false);
                  setWednesday(false);
                  setLoader1(false);
                  
                  setTuesday(true);

                }
                if(getTxt.match("##") || getTxt.match("###")){
                  alert('## aaya hai');

                  setTopDiv(false);
                  setMonday(false);
                  setTuesday(false);
                  setLoader1(false);
                  
                  setWednesday(true);

                }

              }, 1000);
            }
          }
        
        }
      } 
    }
  };

  useEffect(() => {
    // alert('useEffect 8');
    if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
      navigator.mediaDevices.enumerateDevices()
        .then(devices => {
          const hasCamera = devices.some(device => device.kind === 'videoinput');
          if (hasCamera) {
            // Now try to access the camera
            navigator.mediaDevices.getUserMedia({
              video: {
                facingMode: {
                  exact: 'environment',
                },
              },
            })
            .then((stream) => {
              // Stream obtained successfully, you can use it here if needed
              // createVideo(stream);
              let vid = document.createElement('video');
              setVideo(vid);
              if(video != undefined){
                // alert('video ' + video);
                video.setAttribute('autoplay', 'true');
                video.setAttribute('muted', 'true');
                video.setAttribute('playsinline', 'true');
                myVideotagElement.appendChild(video);
                video.srcObject = stream;
                video.onloadedmetadata = () => {
                  video.play();
                };

                video.addEventListener('loadedmetadata', function() {
                  requestAnimationFrame(processFrame);
                });
              }
            })
            .catch((error) => {
              alert('error 1')
              console.error('Error accessing camera:', error);
            });
          } else {
            alert('error 2')
            console.error('No camera found on this device.');
          }
        })
        .catch((error) => {
          console.error('Error enumerating devices:', error);
        });
    } else {
      alert('getUserMedia is not supported in this browser.');
    }
  } );
  

  return (
    <div className="main">
      
      <div id="changeVal">{multyTotalClr}</div>
        {/* <div id="changeVal">{changeVal}</div> */}
        <div id="test">{countNew}</div>
        <div id="averageBrightness">{averageBrightness}</div>
        { readyClick === false ? <div className="clickReady" onClick={clickReadyHandler}></div> : '' }

        { 
          loader1 === true ? <div className="loader1">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
          </div> : ''  
        }
        
        { topDiv === true ? <div className="topDiv"></div> : '' }
        
        <div id="videoTag" ref={myVideotagRef} ></div>
        <p id="decodedOutput"></p>
        <div className="output"></div>
        <div className="outputWithoutComma"></div>
        <div className="outputNew"></div>
        <div className="alpha">{content}</div>

        { monday === true ? <div className="monday"></div> : ''  } 
        { tuesday === true ? <div className="tuesday"></div> : '' }
        { wednesday === true ?  <div className="wednesday"></div> : '' } 
        
      </div>
  )
}

export default VideoPage